<template>
  <div
    class="label"
    v-bind:class="[typeComputed, { disabled: disabledComputed }]"
    @click="Click($event)"
    v-tooltip="tooltip"
  >
    <buttonc
      class="icon-left"
      v-if="iconLeftComputed"
      v-bind="iconLeftComputed"
    />
    <div
      class="text"
      v-bind:style="styleText"
      v-if="textComputed !== undefined"
    >
      {{ textDisplay }}
    </div>
    <div
      class="text shadow"
      v-if="textComputed !== undefined"
      v-bind:style="[{ 'box-shadow': styleShadow }]"
    ></div>
    <div
      class="title"
      v-bind:style="styleText"
      v-if="titleComputed !== undefined"
    >
      {{ titleComputed + ":" }}
    </div>
    <div
      class="info"
      v-bind:style="styleText"
      v-bind:class="InfoClasses()"
      v-if="infoComputed !== null && infoComputed !== undefined"
    >
      {{ infoDisplay }}
    </div>
    <buttonc
      class="icon-right"
      v-if="iconRightComputed"
      v-bind="iconRightComputed"
    />
  </div>
</template>

<script>
export default {
  name: "labelc",
  data() {
    return {
      styleShadow: "",
    };
  },
  props: {
    disabled: [String, Boolean],
    iconLeft: Object,
    iconRight: Object,
    text: [String, Number],
    type: String,
    title: [String, Number],
    info: [String, Number],
    state: Object,
    styleText: String,
    tooltip: [Object, String, Function],
  },
  computed: {
    disabledComputed() {
      if (this.state) return this.state.disabled;
      else return this.disabled;
    },
    iconLeftComputed() {
      if (this.state) return this.state.iconLeft;
      else return this.iconLeft;
    },
    iconRightComputed() {
      if (this.state) return this.state.iconRight;
      else return this.iconRight;
    },
    textComputed() {
      if (this.state) return this.state.text;
      else return this.text;
    },
    typeComputed() {
      if ((!this.state || (this.state && !this.state.type)) && !this.type)
        return "";
      if (this.state) return this.state.type;
      else return this.type;
    },
    titleComputed() {
      if (this.state) return this.state.title;
      else return this.title;
    },
    infoComputed() {
      if (this.state) return this.state.info;
      else return this.info;
    },
    textDisplay() {
      let label = this.textComputed;
      if (this.typeComputed && this.typeComputed.indexOf("number") !== -1) {
        label = this.$helpers.ProcessNumericLabel(label);
      }
      return label;
    },
    infoDisplay() {
      let label = this.infoComputed;
      if (this.typeComputed && this.typeComputed.indexOf("number") !== -1) {
        label = this.$helpers.ProcessNumericLabel(label);
      }
      return label;
    },
  },
  mounted() {
    this.GetShadowStyle();
  },
  methods: {
    InfoClasses() {
      if (this.typeComputed.indexOf("number") === -1) return {};
      let number = parseInt(this.infoComputed);
      let classes = { green: number > 0, red: number < 0, gray: number === 0 };
      return classes;
    },
    Click($event) {
      this.$emit("click", $event);
    },
    GetShadowStyle(color) {
      if (!this.$el) return "";

      let background = getComputedStyle(this.$el).background;
      if (color) background = color;
      else {
        if (background === "") return "";
        background = background.split(" none")[0];
      }
      this.styleShadow =
        "inset -12px 0px 2px -5px " + background + " !important";
    },
  },
};
</script>

<style scoped>
.label {
  margin-left: 5px;
  margin-right: 5px;
  transition: 0.2s;
  display: inline-flex;
}

.label * {
  align-self: center;
  transition: 0.2s;
}

.label.no-break {
  white-space: nowrap;
  /* overflow: hidden; */
}

.label.header {
  font-family: DistrictProBold;
  color: var(--mp);
  font-size: 16px;
}

.label.header.title {
  font-size: 30px;
  float: left;
}

.label.large {
  font-size: 35px;
}
.label.huge {
  font-size: 90px;
}

.label .text {
  margin-right: 5px;
  display: inline-block;
}

.centered .text {
  margin-right: auto;
  margin-left: auto;
  display: inline-block;
}

.label.dark .text {
  color: var(--contrast-4);
}

.label .title {
  margin-right: 5px;
  display: inline-block;
}

.label .info {
  font-family: DistrictProBold;
  display: inline-block;
}

.label .green {
  font-family: DistrictProBold;
  color: var(--mp);
}

.label .red {
  color: #e5154f;
  font-weight: 200;
  font-family: DistrictProLight;
}
.label .gray {
  /*color: var(--contrast-3);*/
  font-weight: 200;
  font-family: DistrictProLight;
}

.label .icon-left {
  border: none;
  box-shadow: none;
  background: none;
}

.label .icon-right {
  border: none;
  box-shadow: none;
  background: none;
  float: right;
  /*color: var(--contrast-2);*/
}

.label.groupheader {
  width: 100%;
  height: 20px;
  margin: 8px 8px 0px 8px;
  padding: 2px 4px;
  font-size: 12px;
  cursor: default;
  pointer-events: initial;
}
.label.groupheader .text {
  pointer-events: none;
  color: var(--mp);
}
.label.block {
  width: 100%;
  height: 40px;
  margin: 0;
  cursor: pointer;
  pointer-events: initial;
}
.label.block .text {
  pointer-events: none;
}
.label.block .button {
  height: 100%;
}
.label.block .button:not(.allow-hover) {
  pointer-events: none;
}
.label.block:hover {
  background: var(--contrast-3);
}
.label.block:hover > .text {
  text-shadow: 0px 0px 0px #404040;
}

.label.border-bottom {
  box-shadow: 0 1px 0 -1px var(--contrast-2);
}

.label.border-top {
  box-shadow: 0 -1px 0 -1px var(--contrast-2);
}
.label.border-bottom.border-top {
  box-shadow: 0 -1px 0 -1px var(--contrast-2), 0 1px 0 -1px var(--contrast-2);
}

.label.bold .text {
  font-family: DistrictProBold;
}

.label.thin .text {
  font-family: DistrictProLight;
  font-weight: 200;
}

.label.ticker .text {
  font-size: 18px;
}

.text.shadow {
  position: absolute;
  right: 0;
  width: 10px;
  height: 100%;
  top: 0;
  margin: 0;
  display: none;
}

.label.shadow .shadow {
  display: initial;
}

.label.shadow {
  box-shadow: none !important; /*gee I sure love bootstrap using common words as class names*/
}

.label.selectable .text {
  user-select: text;
}

.label.center-absolute .text {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
}

.label.tiny .text {
  font-size: 8px;
}

.label.tab > * {
  pointer-events: none;
}

.label.center {
  justify-content: center;
}

.label.day {
  justify-content: center;
  margin-right: 0;
}

.datepicker .text {
  margin: 0;
}

.label.day *,
.label.month * {
  pointer-events: none;
}

.options .label {
  margin: 0;
}

.options .label .text {
  margin: 0;
}

.label.underline {
  box-shadow: inset 0 -2px 0 -1px var(--contrast-3);
  padding-bottom: 5px;
}

.label.space-content {
  justify-content: space-between;
  margin: 0;
  padding: 0;
}

.label.input-error {
  position: absolute;
  top: 0;
  right: -105px;
  bottom: 0;
  margin: auto;
  z-index: 10;
  height: fit-content;
  width: 100%;
  text-align: right;
  justify-content: flex-end;
  pointer-events: none;
}

.label.input-error .text {
  color: var(--contrast-6);
  word-break: keep-all;
  white-space: nowrap;
  font-family: DistrictProLight;
  font-weight: 200;
  font-size: 11px;
  user-select: none;
}
</style>
